export const brandProductEndPoint = `products`;
